const mask = '[js-secondary-body-mask]';
const secondaryBodyCopy = '[js-secondary-body-copy]';
const secondaryBodyOpenerLabel = '[js-secondary-body-opener-label]';
const active = 'active';

function toggleSecondaryBody() {
  const parent = this.parentNode;
  const isOpen = parent.classList.contains(active);

  if (!isOpen) {
    const copyHeight = parent.querySelector(secondaryBodyCopy).offsetHeight;
    parent.classList.add(active);
    parent.querySelector(mask).style.height = `${copyHeight}px`;
    this.querySelector(secondaryBodyOpenerLabel).textContent = 'Show less';
  } else {
    parent.classList.remove(active);
    parent.querySelector(mask).style.height = 0;
    this.querySelector(secondaryBodyOpenerLabel).textContent = 'Show more';
  }
}

function setHeight() {
  setTimeout(() => {
    const activeBodies = document.querySelectorAll(
      '.active[js-secondary-body]'
    );

    Array.prototype.forEach.call(activeBodies, body => {
      const copyHeight = body.querySelector(secondaryBodyCopy).offsetHeight;
      const maskElement = body.querySelector(mask);
      maskElement.style.height = `${copyHeight}px`;
    });
  }, 500);
}

const eventHandler = () => {
  const openers = document.querySelectorAll('[js-secondary-body-opener]');
  Array.prototype.forEach.call(openers, opener => {
    opener.addEventListener('click', toggleSecondaryBody, false);
  });

  window.addEventListener('resize', setHeight);
  window.addEventListener('orientationchange', setHeight);
};

const secondaryBody = () => eventHandler();

export default secondaryBody;
